var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBurger2Icon = function SvgBurger2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillRule: "evenodd",
    d: "M14 7.1a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-.6a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v.6Zm0 4a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-.6a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v.6Z",
    clipRule: "evenodd"
  })));
};
export default SvgBurger2Icon;